<template>
  <div class="eticheta-id-sterilizare flex-center">
    <h1>
      {{ idSterilizare }}
      <br>
      {{ format(new Date(), 'dd MMM, yyyy', { locale: ro }) }}
    </h1>
  </div>
</template>

<script>
  import { format } from 'date-fns';
  import { ro } from 'date-fns/locale';
  import {mapState} from "vuex";

  export default {
    name: "EtichetaIDSterilizare",
    data () {
      return {
        format,
        ro
      }
    },
    computed: {
      ...mapState({
        idSterilizare: state => state.sterilizare.idSterilizare,
      })
    }
  }
</script>

<style lang="less">
  .eticheta-id-sterilizare {
    margin: 0;
    padding: 0;
    width: 65mm;
    height: 10mm;
    overflow: hidden;
    h1 {
      font-size: 1.6rem;
    }
    @page {
      size: 65mm 10mm;
      margin: 0;
    }
  }
</style>
